/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function FastForwardCircle(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M128,24A104,104,0,1,0,232,128,104.11791,104.11791,0,0,0,128,24Zm56.58789,110.55371-40,28A8.00015,8.00015,0,0,1,132,156V128a7.99968,7.99968,0,0,1-3.41211,6.55371l-40,28A8.00015,8.00015,0,0,1,76,156V100a8.00015,8.00015,0,0,1,12.58789-6.55371l40,28A7.99968,7.99968,0,0,1,132,128V100a8.00015,8.00015,0,0,1,12.58789-6.55371l40,28a8,8,0,0,1,0,13.10742Z" />
    </Svg>
  );
}

export default FastForwardCircle;
